import { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { DIALOG_VARIANT } from 'constants/dialog';
import { lazyNamedWithChunkRecovery } from 'helper/lazyWithChunkRecovery';
import { dialogVariantSelector } from 'store/entities/ui/slice';

const dialogModules = import.meta.glob('./*/index.js');

const lazyDialog = (name) => lazyNamedWithChunkRecovery(dialogModules[`./${name}/index.js`], name);

const DIALOGS = {
  [DIALOG_VARIANT.RENAME]: lazyDialog('RenameDialog'),
  [DIALOG_VARIANT.PASS_UPDATE]: lazyDialog('PasswordUpdateDialog'),
  [DIALOG_VARIANT.CREATE_MASTER_DASHBOARD]: lazyDialog('CreateMasterDashboardDialog'),
  [DIALOG_VARIANT.CONFIRMATION]: lazyDialog('ConfirmationDialog'),
  [DIALOG_VARIANT.CONFIRMATION_WITH_INPUT]: lazyDialog('ConfirmationDialogWithInput'),
  [DIALOG_VARIANT.DUPLICATE_PROJECT]: lazyDialog('DuplicateProjectDialog'),
  [DIALOG_VARIANT.RESET_PASSWORD]: lazyDialog('ResetPasswordDialog'),
  [DIALOG_VARIANT.ADD_USER]: lazyDialog('AddUserDialog'),
  [DIALOG_VARIANT.ORGANISATION_USER_DETAILS]: lazyDialog('OrganisationUserDetailsDialog'),
  [DIALOG_VARIANT.LEADERS_PERMISSIONS]: lazyDialog('LeadersPermissionsDialog'),
  [DIALOG_VARIANT.EXPORT_ENTRIES]: lazyDialog('ExportEntriesDialog'),
  [DIALOG_VARIANT.SAVE_CREATED_MASTER_DASHBOARD]: lazyDialog('SaveCreatedMasterDashboardDialog'),
  [DIALOG_VARIANT.START_FEEDBACK_ROUND]: lazyDialog('StartFeedbackRoundDialog'),
  [DIALOG_VARIANT.EDIT_FRAMEWORK_RECIPIENT_DEADLINE]: lazyDialog('EditFrameworkRecipientDeadlineDialog'),
  [DIALOG_VARIANT.KEY_EVENTS]: lazyDialog('KeyEventsDialog'),
  [DIALOG_VARIANT.INVALID_INVITES]: lazyDialog('InvalidInvitesDialog'),
  [DIALOG_VARIANT.NOMINEE_MODAL]: lazyDialog('NomineeModal'),
};

export const DialogManager = () => {
  const variant = useSelector(dialogVariantSelector);

  const Dialog = DIALOGS[variant];

  if (!Dialog) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <Dialog />
    </Suspense>
  );
};
